<form class="timetable-search service-form" [formGroup]="reactiveForm">
  <div class="locations-wrapper flex ms-large-b">
    <div class="flex input-fields flex-3">
      <fin-timetable-location-search
        #originLocationSearch
        class="flex--start flex-1 flex--basis0"
        [parentForm]="reactiveForm"
        [controlName]="'origin'"
        [inputLabel]="'timetable.flightFrom' | finLocalization"
        [panelOpenInputLabel]="'timetable.typeOrSelect.origin' | finLocalization"
        [options$]="originLocations$"
        [initialValue$]="initialOrigin$"
        (selectionDone)="validateSelections(true)"
      ></fin-timetable-location-search>
      <div class="dn-mobile db-tablet-up flex--self-center ms-xsmall-x">
        <fcom-icon-button
          class="flex--nogrow"
          [icon]="{ name: SvgLibraryIcon.SWITCH_FLIGHTS }"
          [theme]="IconButtonTheme.LIGHT_TERTIARY_GHOST"
          [size]="IconButtonSize.MEDIUM"
          [aria]="{ label: 'timetable.aria.switchLocations' | finLocalization }"
          (clickBtn)="switchLocations()"
        >
        </fcom-icon-button>
      </div>
      <fin-timetable-location-search
        #destinationLocationSearch
        class="flex--start flex-1 flex--basis0"
        [parentForm]="reactiveForm"
        [controlName]="'destination'"
        [inputLabel]="'timetable.flightTo' | finLocalization"
        [panelOpenInputLabel]="'timetable.typeOrSelect.destination' | finLocalization"
        [options$]="destinationLocations$"
        [initialValue$]="initialDestination$"
        (selectionDone)="validateSelections(false)"
      ></fin-timetable-location-search>
    </div>
    <div class="df-mobile dn-mobile-up flex-1 flex--self-center flex--basis0 mr-small-l">
      <fcom-icon-button
        class="flex--nogrow"
        [icon]="{ name: SvgLibraryIcon.SWITCH_FLIGHTS }"
        [theme]="IconButtonTheme.LIGHT_TERTIARY_GHOST"
        [size]="IconButtonSize.MEDIUM"
        [aria]="{ label: 'timetable.aria.switchLocations' | finLocalization }"
        (clickBtn)="switchLocations()"
      >
      </fcom-icon-button>
    </div>
  </div>
  <div class="flex flex--row flex--wrap pr-medium-b">
    <fcom-checkbox formControlName="directFlights" name="directFlights">
      <span class="font-body-1 medium-type">
        {{ 'timetable.filter.directFlights.label' | finLocalization }}
      </span>
    </fcom-checkbox>
  </div>
</form>
